import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {authHeader} from '../../utils/headers';

// Base API (resources API Platform à la racine).
const API_BASE = import.meta.env.VITE_APIURL || '';

export const consignesApi = createApi({
    reducerPath: 'consignesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE,
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            // Force le JSON-LD Hydra (réponses avec @id, cohérent avec le reste de l'app).
            headers.set('Accept', 'application/ld+json');
            return headers;
        },
    }),
    tagTypes: ['Consigne'],
    endpoints: (builder) => ({
        getConsignes: builder.query({
            query: () => '/consignes',
            transformResponse: (r) => r?.['hydra:member'] ?? (Array.isArray(r) ? r : []),
            providesTags: (result) =>
                result
                    ? [...result.map((c) => ({type: 'Consigne', id: c.id})), {type: 'Consigne', id: 'LIST'}]
                    : [{type: 'Consigne', id: 'LIST'}],
        }),
        getConsigne: builder.query({
            query: (id) => `/consignes/${id}`,
            providesTags: (result, error, id) => [{type: 'Consigne', id}],
        }),
        createConsigne: builder.mutation({
            query: (body) => ({
                url: '/consignes',
                method: 'POST',
                headers: {'Content-Type': 'application/ld+json'},
                body: JSON.stringify(body),
            }),
            invalidatesTags: [{type: 'Consigne', id: 'LIST'}],
        }),
        updateConsigne: builder.mutation({
            query: ({id, ...patch}) => ({
                url: `/consignes/${id}`,
                method: 'PATCH',
                headers: {'Content-Type': 'application/merge-patch+json'},
                body: JSON.stringify(patch),
            }),
            invalidatesTags: (result, error, {id}) => [{type: 'Consigne', id}, {type: 'Consigne', id: 'LIST'}],
        }),
        deleteConsigne: builder.mutation({
            query: (id) => ({
                url: `/consignes/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{type: 'Consigne', id: 'LIST'}],
        }),
    }),
});

export const {
    useGetConsignesQuery,
    useGetConsigneQuery,
    useCreateConsigneMutation,
    useUpdateConsigneMutation,
    useDeleteConsigneMutation,
} = consignesApi;
